import { api } from '..'

import {
  DriverProfileDto,
  LoginRequestDto,
  LoginResponseDto,
  RefreshTokenRequestDto,
  RefreshTokenResponseDto,
  SendCodeRequestDto,
} from './AuthService.dto'

export const authApi = api.injectEndpoints({
  endpoints: (builder) => ({
    login: builder.mutation<LoginResponseDto, LoginRequestDto>({
      query: (credentials) => ({
        url: 'auth/login',
        method: 'POST',
        body: credentials,
      }),
      invalidatesTags: ['Auth'],
    }),
    refreshToken: builder.mutation<RefreshTokenResponseDto, RefreshTokenRequestDto>({
      query: (payload) => ({
        url: 'auth/RefreshToken/refresh-token',
        method: 'POST',
        body: payload,
      }),
      invalidatesTags: ['Auth'],
    }),
    logout: builder.mutation<void, void>({
      query: () => ({
        url: 'auth/Logout/logout',
        method: 'POST',
      }),
      invalidatesTags: ['Auth'],
    }),
    sendVerificationCode: builder.mutation<void, SendCodeRequestDto>({
      query: (payload) => ({
        url: 'auth/SendVerificationCode',
        method: 'POST',
        body: payload,
      }),
    }),
    getDriverProfile: builder.query<DriverProfileDto, void>({
      query: () => ({
        url: 'auth/GetProfile/driver-profile',
        method: 'GET',
      }),
      providesTags: ['Auth'],
    }),
  }),
})

export const {
  useLazyGetDriverProfileQuery,
  useLoginMutation,
  useLogoutMutation,
  useRefreshTokenMutation,
  useSendVerificationCodeMutation,
} = authApi
